const init = {
    status:false,
    message:'',
    data:{}
}

export const setOrganizationsReducer = (state = init, action) => {
    switch (action.type){
        case 'SET_ORGANIZATION_START':
            return state;
        case 'SET_ORGANIZATION_FAIL':
            return {...state, message:action.payload.message,status:false};
        case 'SET_ORGANIZATION_EXCEPTION':
            return {...state, message:action.payload,status:false};
        case 'SET_ORGANIZATION_SUCCESS':
            return {...state, data:action.payload, status:true };
        default:
            return state;
    }
};